import Swiper, { Navigation, Pagination, Lazy, Autoplay } from "swiper";

Swiper.use([Navigation, Pagination, Lazy, Autoplay]);

const sliderPromotions = document.querySelector(".js-promotion-participates-swiper-init");

if (sliderPromotions) {
    window.addEventListener("load", () => initPromotionParticipatesSlider(sliderPromotions));
}

const initPromotionParticipatesSlider = (slider) => {
    const swiperContainer = slider.querySelector(".js-promotion-participates-swiper-container");
    const swiperControls = slider.querySelector(".js-articles-swiper-controls");
    const slides = swiperContainer?.querySelectorAll(".swiper-slide");

    if (slides && slides.length < 2) {
        if (swiperControls) swiperControls.style.display = "none";

        return;
    }

    if (swiperContainer && swiperControls) {
        const pagination = swiperControls.querySelector(".swiper-pagination");
        const buttonPrev = swiperControls.querySelector(".swiper-button-prev");
        const buttonNext = swiperControls.querySelector(".swiper-button-next");

        new Swiper(swiperContainer, {
            observeParents: true,
            observer: true,
            observeSlideChildren: true,
            slidesPerView: 1,
            loop: window.mobileMedia,
            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },
            pagination: {
                el: pagination,
                dynamicBullets: !window.mobileMedia,
                dynamicMainBullets: 3,
                clickable: true,
            },
        });

        if (window.mobileMedia && pagination) {
            const bottomBlock = slider.querySelector(".promotion-participates__bottom");

            if (bottomBlock) {
                const computedGap = parseFloat(window.getComputedStyle(slider).gap) || 0;

                pagination.style.bottom = `${bottomBlock.offsetHeight + computedGap + 8}px`;
            }
        }
    }
};
